import { authenticatedPatientSelector, currentPatientSelector } from '../selectors/patients-selectors.ts';

module.exports = {
  controller: class PatientHeaderController {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$state',
    ];

    routesWithoutHeader = ['privacy_statement', 'patient_agreement', 'reset_password', 'activation'];

    constructor($ngRedux, $scope, $state) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
    }

    $onInit() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        authenticatedPatient: authenticatedPatientSelector(state),
        currentPatient: currentPatientSelector(state),
        group: state.group,
      }))(this));
    }

    get isVisible() {
      if (this.$state.current.name === 'login') {
        return !!this.group.logoPictureUrl;
      }
      return !_.includes(this.routesWithoutHeader, this.$state.current.name);
    }
  },
  template: `
    <div>
      <header class="patient-header" ng-show="$ctrl.isVisible">
        <div class="wrapper">
          <div class="header-elements">
            <group-info group="$ctrl.group"></group-info><!--
    
            --><div class="l-menus" ng-if="$ctrl.currentPatient.id">
              <patient-selector authenticated-patient="$ctrl.authenticatedPatient" current-patient="$ctrl.currentPatient" group="$ctrl.group"></patient-selector>
              <account-menu></account-menu>
            </div>
          </div>
    
          <div class="header-elements -mobile">
            <group-info group="$ctrl.group"></group-info><!--
    
            --><div class="l-menus" ng-if="$ctrl.currentPatient.id">
              <account-menu></account-menu>
              <patient-selector authenticated-patient="$ctrl.authenticatedPatient" current-patient="$ctrl.currentPatient" group="$ctrl.group"></patient-selector>
            </div>
          </div>
        </div>
      </header>
    
      <div class="mobile-selector wrapper" ng-show="$ctrl.isVisible">
        <p class="greeting">{{ 'home.greeting' | translate:{patientFirstName: $ctrl.currentPatient.firstName} }}</p>
        <patient-selector authenticated-patient="$ctrl.authenticatedPatient" current-patient="$ctrl.currentPatient" group="$ctrl.group"></patient-selector>
      </div>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/patient-header.js